var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H18V9.96875C18 9.4375 17.5625 9 17.0312 9H10.5V7H12C12.5312 7 13 6.5625 13 6V3C13 2.46875 12.5312 2 12 2H8C7.4375 2 7 2.46875 7 3V6C7 6.5625 7.4375 7 8 7H9.5V9H2.9375C2.40625 9 2 9.4375 2 9.96875V13H1C0.4375 13 0 13.4688 0 14V17C0 17.5625 0.4375 18 1 18H4C4.53125 18 5 17.5625 5 17V14C5 13.4688 4.53125 13 4 13H3V10H9.5V13H8.5C7.9375 13 7.5 13.4688 7.5 14V17C7.5 17.5625 7.9375 18 8.5 18H11.5C12.0312 18 12.5 17.5625 12.5 17V14C12.5 13.4688 12.0312 13 11.5 13H10.5V10H17V13H16C15.4375 13 15 13.4688 15 14V17C15 17.5625 15.4375 18 16 18H19C19.5312 18 20 17.5625 20 17V14C20 13.4688 19.5312 13 19 13ZM4 14V17H1V14H4ZM11.5 14V17H8.5V14H11.5ZM8 6V3H12V6H8ZM19 17H16V14H19V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.97654aac.svg";
export { ForwardRef as ReactComponent };